<drawer [title]="sectionTitle"
        [contextLabel]="regDeterminant?.determinant?.name || regDeterminant?.name"
        [contextLabelTooltip]="regDeterminant?.registration?.name"
        [showHeader]="true"
        [isClosed]="false"
        [noContentPadding]="true"
        (saveEvent)="store.state.common.determinantSection.topLayer === 'edit' ? closeEdit() : onSave()"
        [embedded]=false
        (closeEvent)="closeLayer();"
        class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-builder-new [serviceId]="serviceId"
            [jsonString]="jsonString"
            [showSaveCancelRow]=false
            (onCancel)="closeLayer()"
            (onChange)="change($event)"
            class="d-flex overflow-hidden mh-100 h-100  w-100 {{store.state.common.determinantSection.topLayer === 'edit' ? 'd-none' : ''}} flex-column"></determinant-builder-new>
        <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
            class="d-flex overflow-hidden mh-100 w-100 flex-column"
            [serviceId]="serviceId"
            [isClosed]="false"
            [determinant]="store.state.common.determinantSection.determinant"
            (formSubmit)="closeEdit()"
            (editCancel)="closeEdit()"></determinant-new>
    </div>
</drawer>
